import { useState } from "react";
import { Text } from "../ui/text";

const TypeTag = ({
  excuteType,
}: {
  excuteType:
    | "ANALYSIS"
    | "ANALYSIS_ETC"
    | "FILEUPLOAD"
    | "RESEARCH"
    | "REANALYSIS_COMBINE"
    | "REANALYSIS_MODIFY";
}) => {
  const [isHover, setIsHover] = useState(false);

  let isHoverClass;
  let basicClass;

  if (excuteType === "FILEUPLOAD") {
    isHoverClass = "bg-primary-90 text-primary-0";
    basicClass = "bg-white text-grey-20";
  } else if (excuteType === "RESEARCH") {
    isHoverClass = "bg-[#D6E4FF] text-[#276DF4]";
    basicClass = "bg-grey-90 text-grey-0";
  } else if (excuteType === "REANALYSIS_COMBINE") {
    isHoverClass = "bg-[#FFDADD] text-[#FF4E57]";
    basicClass = "bg-grey-50 text-white";
  }

  return (
    <div>
      <div className="flex gap-1 relative">
        <div
          onMouseEnter={() => setIsHover(true)}
          onMouseLeave={() => setIsHover(false)}
          className={`cursor-pointer border border-grey-90 rounded-[2px] h-[20px] w-[25px] flex justify-center items-center ${
            isHover ? isHoverClass : basicClass
          }`}
        >
          <Text variant={"label-md"} className="text-inherit">
            {excuteType === "FILEUPLOAD" && "UP"}
            {excuteType === "RESEARCH" && "RS"}
            {excuteType === "REANALYSIS_COMBINE" && "RA"}
          </Text>
        </div>
        {isHover && (
          <div
            className={`rounded-[2px] absolute top-0 left-8 whitespace-nowrap h-[20px] w-[90px] flex justify-center items-center ${isHoverClass}`}
          >
            <Text variant={"label-md"} className="text-inherit">
              {excuteType === "FILEUPLOAD" && "Uploaded Job"}
              {excuteType === "RESEARCH" && "Re-Searched"}
              {excuteType === "REANALYSIS_COMBINE" && "Re-Analysis"}
            </Text>
          </div>
        )}
      </div>
    </div>
  );
};

export default TypeTag;
